<template>
  <div class="algorithm-config">
    <div class="algorithm-config__quickChooseBox" v-if="showQuickChoose">
      <div class="algorithm-config__quickChooseBox__label">推送方式：</div>
      <div class="algorithm-config__quickChooseBox__btnsBox">
        <el-select
          v-model="pushType"
          class="algorithm-config__quickChooseBox__btnItem"
          placeholder="请选择"
          @change="typeBtnChange"
        >
          <el-option
            v-for="item in btnList"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <!-- <div
          class="algorithm-config__quickChooseBox__btnItem"
          v-for="(item, index) in btnList"
          :key="index"
          @click="typeBtnChange(item)"
        >
          <el-button size="small" :type="pushType === item.id ? 'primary' : ''">
            {{ item.text }}
          </el-button>
        </div> -->
      </div>
      <div class="algorithm-config__quickChooseBox__label" style="width: 80px;">
        历史版本：
      </div>
      <el-select
        v-model="historyVersion"
        class="algorithm-config__quickChooseBox__historyVersion"
        placeholder="请选择"
        @change="handleHistoryVersionChange"
      >
        <el-option
          v-for="option in historyOptions"
          :key="option.value"
          :label="option.label + getPushType(option.pushType)"
          :value="option.value"
        >
        </el-option>
      </el-select>
    </div>
    <ul class="algorithm-config__list" v-loading="loading">
      <li>
        <div class="algorithm-config__header">
          <h3>
            学者来源
            <el-tooltip
              class="item"
              effect="dark"
              content="Right Top 提示文字"
              placement="right-start"
              v-if="isMedicalAssociationEnv"
            >
              <div slot="content" class="algorithm-config__tooltipContent">
                <p
                  v-for="(item, index) in scholarSources(
                    pushType,
                    scholarTextArr
                  )"
                  :key="index"
                >
                  {{ index + 1 }} {{ item.text }}
                </p>
              </div>
              <img
                style="cursor: help;width: 12px;height: 12px;margin-left: 4px;"
                src="@/assets/img/info-card-help.png"
                alt="help"
              />
            </el-tooltip>
          </h3>
        </div>
        <div class="algorithm-config__header" v-show="!hideLwfw">
          <h3>论文范围</h3>
        </div>
        <div class="algorithm-config__header">
          <h3>学者行为</h3>
        </div>
        <div class="algorithm-config__header">
          <h3>学者特征</h3>
        </div>
      </li>
      <li v-for="(item, index) in customPushList" :key="index">
        <div class="algorithm-config__wrap">
          <div class="algorithm-config__checkboxIndex">
            <span>{{ index + 1 }}</span>
            <el-checkbox
              v-model="item.status"
              :true-label="1"
              :false-label="0"
              @change="handleIndexChange(item)"
              >{{ item.name }}</el-checkbox
            >
          </div>
        </div>
        <div
          class="algorithm-config__wrap"
          v-for="(subItem, subIndex) in item.groupList"
          :key="subIndex"
          @click="handleClick(item)"
          v-show="subItem.name === '论文范围' ? !hideLwfw : true"
        >
          <div class="algorithm-config__checkbox">
            <div class="algorithm-config__label" v-if="index === 0">
              <span
                v-for="(checkboxItem, checkboxIndex) in subItem.choiceList"
                :key="checkboxIndex"
                >{{ checkboxItem.name
                }}<el-tooltip
                  v-if="
                    isMedicalAssociationEnv && tooltipMap[checkboxItem.name]
                  "
                  class="item"
                  effect="dark"
                  :content="tooltipMap[checkboxItem.name]"
                  placement="top-start"
                >
                  <img
                    style="cursor: help;width: 12px;height: 12px;margin-left: 4px;"
                    src="@/assets/img/info-card-help.png"
                    alt="help"
                  /> </el-tooltip
              ></span>
            </div>
            <el-checkbox
              :disabled="item.status !== 1 || checkboxItem.status === -1"
              v-for="(checkboxItem, checkboxIndex) in subItem.choiceList"
              :key="checkboxIndex"
              v-model="checkboxItem.status"
              :true-label="1"
              :false-label="0"
              @change="handleChange(checkboxItem, subItem, subIndex)"
            ></el-checkbox>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Get, Post, ProjectConfig } from '@/api'
import { mapGetters } from 'vuex'
import { scholarSources, scholarTextArr, tooltipMap } from './common'
const increment = ProjectConfig.increment
export default {
  name: 'AlgorithmConfig',
  props: {
    taskId: {
      type: String || Number,
      default: ''
    },
    showQuickChoose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      scholarTextArr,
      customPushList: [],
      pushType: '',
      taskType: '',
      tooltipMap,
      btnList: [
        {
          text: '普通推送',
          id: 10
        },
        {
          text: '白名单推送',
          id: 11
        },
        {
          text: '智能推送',
          id: 8
        }
      ],
      historyVersion: '',
      historyOptions: [],
      currentTask: null,
      // taskId: '',
      loading: false
      // 学者来源说明s
    }
  },
  computed: {
    ...mapGetters(['isMedicalAssociationEnv', 'isCluster']),
    // 是否隐藏论文范围
    hideLwfw() {
      return !this.isMedicalAssociationEnv && this.isCluster
    }
  },
  watch: {
    pushType: {
      handler(nv) {
        if (nv) {
          this.$emit('typeBtnChange', nv)
        }
      },
      immediate: true
    }
  },
  created() {
    this.taskType = Number(this.$route.query.type)
    this.getHistoryOptions()
    if (this.$route.query.pushType) {
      this.pushType = Number(this.$route.query.pushType)
      this.getPushTypeDefault(true)
    }
  },
  methods: {
    scholarSources,
    async getHistoryOptions() {
      const res = await Get(increment.GetSendVersionGroupType.url)
      if (res && res.data && res.data.status === 0) {
        this.historyOptions =
          res.data.data.map((item) => {
            return {
              label: item.createTime.replace('T', ' '),
              value: item.version,
              ...item
            }
          }) || []
      }
    },
    // 历史版本切换
    handleHistoryVersionChange() {
      console.log(this.historyVersion, 'historyVersion')
      this.getCustomScholar()
    },
    // 操作学者来源
    handleIndexChange(item) {
      console.log(item, 'item')
      // 取消选中学者来源，则取消选中整行的选中
      if (item.status !== 1) {
        item.groupList.forEach((groupItem) => {
          groupItem.choiceList.forEach((choiceItem) => {
            choiceItem.status = 0
          })
        })
      } else {
        item.groupList = JSON.parse(JSON.stringify(item.oldGroupList))
      }
    },
    // 生成随机uuid
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
        c
      ) {
        const r = (Math.random() * 16) | 0
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    // 自定义学者确定
    async setCustomScholar() {
      return new Promise((resolve, reject) => {
        Post(
          increment.SaveDefaultSetChoice.url +
            '?taskType=' +
            this.taskType +
            '&pushType=' +
            this.pushType,
          this.customPushList
        ).then((res) => {
          if (res && res.data && res.data.status === 0) {
            resolve(this.pushType)
          } else {
            const { message = '' } = res.data
            this.$message.error(message)
            reject(message)
          }
        })
      })
    },
    // 推送学者类型切换
    typeBtnChange(item) {
      this.pushType = item
      // 切换直接读取默认值进行回显
      this.historyVersion = ''
      this.getPushTypeDefault()
    },
    getPushType(pushType) {
      let pushTypeObj = this.btnList.find((item) => item.id === pushType)
      return pushTypeObj ? '-' + pushTypeObj?.text : ''
    },
    // 获取默认配置
    getPushTypeDefault(isLoad) {
      return new Promise((resolve) => {
        let params = {
          pushType: this.pushType,
          taskType: this.taskType
        }
        this.loading = true
        Get(increment.GetDefaultPushConfig.url, { params }).then((res) => {
          if (res && res.data && res.data.status === 0) {
            this.customPushList = res.data.data.map((item) => {
              return {
                ...item,
                oldGroupList: JSON.parse(JSON.stringify(item.groupList)) // 存储默认的配置
              }
            })
            console.log(this.customPushList, '数据2312')
            // 进入页面第一次获取上次的配置进行回显
            if (isLoad) {
              this.getCustomScholar()
            } else {
              this.loading = false
            }
          } else {
            this.$message.error(res.data.message)
            this.loading = false
          }
          resolve()
        })
      })
    },
    // 获取上次保存的配置
    getCustomScholar() {
      let params = {}
      let $aipUrl = increment.GetDefaultSetChoice.url
      // 历史版本筛选
      if (this.historyVersion) {
        let versionData = this.historyOptions.find(
          (item) => item.value === this.historyVersion
        )
        params.version = versionData.version
        params.historyId = versionData.historyId
        this.pushType = versionData.pushType
        $aipUrl = increment.GetAuthorChoice.url
      } else {
        params.taskType = this.taskType
        params.pushType = this.pushType || ''
      }
      Get($aipUrl, { params })
        .then(async (res) => {
          if (res && res.data && res.data.status === 0) {
            let { data } = res.data
            if (data && data.length > 0) {
              /*
                customPushList是先取的getDefalut默认值，
                然后拿之前保存的根据name匹配进行赋值，这样能解决接口加了新的配置，但是之前用旧配置保存过导致显示不出来的问题
              */
              if (this.customPushList.length > 0) {
                data.forEach((item) => {
                  let findIndex = this.customPushList.findIndex(
                    (it) => it.name === item.name
                  )
                  let findData = {
                    ...item,
                    groupList:
                      item.groupList && item.groupList.length
                        ? item.groupList
                        : this.customPushList[findIndex]?.groupList || [],
                    oldGroupList:
                      this.customPushList[findIndex]?.oldGroupList || []
                  }
                  this.$set(this.customPushList, findIndex, findData)
                })
              } else {
                this.customPushList = data
              }
            } else {
              if (this.customPushList.length === 0) {
                await this.getPushTypeDefault()
              }
              this.customPushList.forEach((item) => {
                item.status = 0
                if (item.groupList && item.groupList.length > 0) {
                  item.groupList.forEach((group) => {
                    if (group.choiceList && group.choiceList.length > 0) {
                      group.choiceList.forEach((choice) => {
                        choice.status = 0
                      })
                    }
                  })
                }
              })
            }
          } else {
            const { message = '' } = res.data
            this.$message.error(message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 保存
    save() {
      console.log(this.customPushList, 'customPushList')
    },
    handleChange(checkboxItem, subItem, index) {
      if (index !== 2) {
        subItem.choiceList.forEach((item) => {
          if (item.name === checkboxItem.name) {
            item.status = checkboxItem.status
          } else {
            if (item.status !== -1) {
              item.status = 0
            }
          }
        })
      }
    },
    handleClick(item) {
      if (item.status !== 1) {
        this.$message.error('当前学者来源未选择，此选项禁用')
      }
      console.log(item, 'item')
    },
    // 校验论文范围是否为空，返回第一个校验失败的学者来源名称，全部通过则返回 null
    validatePaperRange() {
      // 论文范围列隐藏时无需校验
      if (this.hideLwfw) return null
      for (const item of this.customPushList) {
        // 医学会环境跳过注册用户
        if (this.isMedicalAssociationEnv && item.name === '注册用户') {
          continue
        }
        // 只校验已选中的学者来源
        if (item.status !== 1) continue
        // 查找论文范围分组
        const paperRangeGroup =
          item.groupList && item.groupList.find((g) => g.name === '论文范围')
        if (
          paperRangeGroup &&
          paperRangeGroup.choiceList &&
          paperRangeGroup.choiceList.length > 0
        ) {
          const hasSelected = paperRangeGroup.choiceList.some(
            (c) => c.status === 1
          )
          if (!hasSelected) {
            return item.name
          }
        }
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.algorithm-config {
  min-width: 1200px;
  &__tooltipContent {
    p {
      margin-bottom: 10px;
    }
  }
  &__list {
    > li {
      display: flex;
    }
    min-height: 300px;
  }
  &__wrap {
    box-sizing: border-box;
    position: relative;
    min-height: 40px;
    border-right: 1px solid #666;
    display: flex;
    align-items: center;
    &:last-child {
      border-right: none;
      flex: 1;
    }
    &:first-child {
      width: 20%;
      min-width: 300px;
    }
    &:nth-child(2) {
      width: 20%;
    }
    &:nth-child(3) {
      // width: 25%;
      flex: 1;
    }
  }
  &__header {
    border-bottom: 1px solid #000;
    border-right: 1px solid #666;
    padding-bottom: 40px;
    text-align: center;
    box-sizing: border-box;
    &:last-child {
      border-right: none;
      flex: 1;
    }
    &:first-child {
      width: 20%;
      min-width: 300px;
    }
    &:nth-child(2) {
      width: 20%;
    }
    &:nth-child(3) {
      // width: 25%;
      flex: 1;
    }
  }
  &__label {
    position: absolute;
    left: 0;
    top: -40px;
    display: flex;
    width: 100%;
    span {
      flex: 1;
      text-align: center;
      display: -webkit-box; /* 使用 Flexbox 的一种特殊模式 */
      -webkit-box-orient: vertical; /* 垂直排列子项 */
      -webkit-line-clamp: 2; /* 限制为两行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 溢出文本显示省略号 */
    }
  }
  &__checkbox {
    display: flex;
    width: 100%;
    .el-checkbox {
      flex: 1;
      text-align: center;
    }
  }
  &__checkboxIndex {
    display: flex;
    width: 100%;
    > span {
      width: 30%;
    }
  }
  &__quickChooseBox {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    &__label {
      font-size: 14px;
      width: 80px;
    }
    &__btnsBox {
      display: flex;
      gap: 20px;
      margin-right: 30px;
    }
    &__historyVersion {
      width: 250px;
    }
  }
}
</style>
